module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-screen"
  }, [_c('a', {
    staticClass: "close",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('span', {
    staticClass: "close__title"
  }, [_vm._v("Esc")])]), _vm._v(" "), _c('div', {
    staticClass: "add-pharmacy-wrapper"
  }, [_c('div', {
    staticClass: "pre-title"
  }, [_vm._v("Добавление стеллажа")]), _vm._v(" "), _c('div', {
    staticClass: "pharmacy-add-title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rName),
      expression: "rName"
    }],
    staticClass: "pharmacy-add-title__input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.rName)
    },
    on: {
      "keyup": function() {
        _vm.autoTitleIsOn = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autoTitleIsOn),
      expression: "autoTitleIsOn"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox",
      "name": "selected-variant",
      "id": "auto"
    },
    domProps: {
      "checked": Array.isArray(_vm.autoTitleIsOn) ? _vm._i(_vm.autoTitleIsOn, null) > -1 : (_vm.autoTitleIsOn)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.autoTitleIsOn,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.autoTitleIsOn = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.autoTitleIsOn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.autoTitleIsOn = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label label--checkbox",
    attrs: {
      "for": "auto"
    }
  }, [_vm._v("Авто")])]), _vm._v(" "), _c('div', {
    staticClass: "product-edit__size form-block"
  }, [_c('div', {
    staticClass: "rack-countour",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showEditContour.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "rack",
    style: (_vm.rack)
  }), _vm._v(" "), _c('svg', {
    staticClass: "extra-background",
    style: (_vm.rack),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "id": "backgroundimage",
      "name": "backgroundimage",
      "viewBox": _vm.viewbox
    }
  }, [_c('g', {
    attrs: {
      "fill": "none"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Path",
      "stroke": "#F79700",
      "stroke-width": "1",
      "points": _vm.shelfContour
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form__block-title"
  }, [_vm._v("Габариты, мм")]), _vm._v(" "), _c('material-input', {
    attrs: {
      "parentClass": "inline",
      "label": "Ширина",
      "type": "number",
      "valueNumber": _vm.width
    },
    on: {
      "inputNumber": function($event) {
        _vm.width = $event
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("x")]), _vm._v(" "), _c('material-input', {
    attrs: {
      "parentClass": "inline",
      "label": "Высота",
      "type": "number",
      "valueNumber": _vm.height
    },
    on: {
      "inputNumber": function($event) {
        _vm.height = $event
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("x")]), _vm._v(" "), _c('material-input', {
    attrs: {
      "parentClass": "inline",
      "label": "Глубина",
      "type": "number",
      "valueNumber": _vm.depth
    },
    on: {
      "inputNumber": function($event) {
        _vm.depth = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-block"
  }, [_c('div', {
    staticClass: "form__block-title"
  }, [_vm._v("Высота первой полки")]), _vm._v(" "), _c('material-input', {
    attrs: {
      "parentClass": "inline",
      "label": "мм",
      "type": "number",
      "valueNumber": _vm.firstShelf
    },
    on: {
      "inputNumber": function($event) {
        _vm.firstShelf = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-block"
  }, [_c('div', {
    staticClass: "form__block-title"
  }, [_vm._v("Количество полок")]), _vm._v(" "), _c('material-input', {
    attrs: {
      "parentClass": "inline",
      "label": "шт",
      "type": "number",
      "valueNumber": _vm.shelfCount
    },
    on: {
      "inputNumber": function($event) {
        _vm.shelfCount = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "50px"
    }
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("Сохранить")])])]), _vm._v(" "), (_vm.isInEditContour) ? _c('div', {
    staticClass: "full-screen"
  }, [_c('a', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isInEditContour = false
      }
    }
  }, [_c('span', {
    staticClass: "close__title"
  }, [_vm._v("Esc")])]), _vm._v(" "), _c('div', {
    staticClass: "rack-contour-editor-holder",
    on: {
      "mousemove": _vm.mousemove,
      "mouseup": _vm.mouseup,
      "mouseleave": _vm.mouseup
    }
  }, [_c('div', {
    staticClass: "rack-contour-editor",
    style: (_vm.rackEditor)
  }, [_vm._l((_vm.draggablePoints), function(point, index) {
    return _c('draggable-point', {
      attrs: {
        "top": point.y,
        "left": point.x,
        "type": point.type,
        "insertPos": point.insertPos,
        "lineIndex": point.lineIndex,
        "id": point.id
      },
      on: {
        "mousedown": _vm.mousedown,
        "remove": _vm.remove
      }
    })
  }), _vm._v(" "), _c('svg', [_c('g', [_c('path', {
    attrs: {
      "d": _vm.contour
    }
  })]), _vm._v(" "), _vm._l((_vm.guides), function(line) {
    return _c('line', {
      attrs: {
        "x1": line.x1,
        "y1": line.y1,
        "x2": line.x2,
        "y2": line.y2,
        "stroke": "red",
        "stroke-width": "1"
      }
    })
  }), _vm._v(" "), _c('g', _vm._l((_vm.guides), function(line) {
    return _c('text', {
      attrs: {
        "x": (line.x1 + line.x2) / 2 - 30,
        "y": (line.y1 + line.y2) / 2 - 20
      }
    }, [_vm._v("\n              " + _vm._s(Math.sqrt(Math.pow((line.x2 - line.x1), 2) + Math.pow((line.y2 - line.y1), 2))) + " см\n            ")])
  }), 0)], 2)], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "50px"
    }
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isInEditContour = false
      }
    }
  }, [_vm._v("Сохранить")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f8f9dc8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pharmacy/rack/RackAdd.vue
// module id = 237
// module chunks = 1